"use strict";

exports.__esModule = true;
exports.convertDataForTableFormat = void 0;
var _timeFormatters = require("../../../Utils/timeFormatters");
var convertDataForTableFormat = exports.convertDataForTableFormat = function convertDataForTableFormat(data, timezone, device, dataItems, valueFormatter) {
  if (!valueFormatter) {
    valueFormatter = function valueFormatter(value) {
      return value;
    };
  }
  var deviceName = device.name;
  var result = [];
  for (var _i = 0, _Object$entries = Object.entries(data); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _Object$entries[_i],
      _ = _Object$entries$_i[0],
      groupedData = _Object$entries$_i[1];
    var _loop = function _loop() {
      var _Object$entries2$_i = _Object$entries2[_i2],
        key = _Object$entries2$_i[0],
        value = _Object$entries2$_i[1];
      var dataItem = dataItems == null ? void 0 : dataItems.find(function (item) {
        return item.name === key;
      });
      if (dataItem) {
        result.push({
          device: deviceName,
          name: dataItem.displayName,
          values: value.filter(function (v) {
            return v.length > 1;
          }).map(function (v) {
            return {
              timestamp: (0, _timeFormatters.formatToDateTime)(v[0], timezone),
              value: valueFormatter(v[1])
            };
          })
        });
      }
    };
    for (var _i2 = 0, _Object$entries2 = Object.entries(groupedData); _i2 < _Object$entries2.length; _i2++) {
      _loop();
    }
  }
  return result;
};